{
  "email": "Email",
  "emailAddress": "Adresse Email",
  "emailAddressPlaceholder": "Entrez votre adresse email",
  "continue": "Continuer",
  "send": "Envoyer",
  "resend": "Renvoyer",
  "sendCodeErrorTip": "Échec de l'envoi du code : {error}",
  "sendEmailTips": "Un code de vérification a été envoyé à votre email",
  "verificationCode": "Code de vérification",
  "codePlaceholder": "Entrez le code",
  "wallet": "Portefeuille",
  "otherLoginMethods": "Autres méthodes de connexion",
  "login": "Connexion",
  "user": "Utilisateur",
  "loginTitle": "Connexion / Inscription",
  "loginTips": "Vous pouvez utiliser les méthodes suivantes",
  "passwordMinError": "Le mot de passe doit contenir au moins {length} caractères",
  "passwordMatchError": "Les mots de passe ne correspondent pas",
  "passwordTitle": "Définir un mot de passe",
  "passwordTips": "Veuillez définir le mot de passe pour restaurer le portefeuille",
  "password": "Mot de passe",
  "passwordPlaceholder": "Entrez votre mot de passe",
  "rePassword": "Confirmer le mot de passe",
  "rePasswordPlaceholder": "Ressaisissez le mot de passe",
  "recoverTitle": "Restaurer le portefeuille",
  "recoverTips": "Entrez votre mot de passe pour restaurer le portefeuille",
  "bindWith": "Lier avec le portefeuille {name}",
  "loginWith": "Connexion avec le portefeuille {name}",
  "editUsernameTitle": "Modifier le nom d'utilisateur",
  "setUsernameTitle": "Définir un nom d'utilisateur",
  "username": "Nom d'utilisateur",
  "usernamePlaceholder": "Entrez votre nom d'utilisateur",
  "usernameValidError": "Le nom peut contenir des lettres, chiffres et caractères",
  "usernameLengthError": "Le nom doit comporter au moins 2 caractères",
  "confirm": "Confirmer",
  "nextTime": "La prochaine fois",
  "setUsername": "Définir un nom d'utilisateur",
  "disconnect": "Déconnecter",
  "CEXBindTitle": "Lier l'API {type}",
  "CEXBindAttention": "Attention :",
  "CEXBindTips1": "1. Veuillez lier l'API avec des permissions en lecture seule.",
  "CEXBindTips2": "2. Votre API peut être obsolète, il est préférable d'utiliser une API à long terme.",
  "CEXBindTips3": "3. Une seule API peut être liée au même échange à la fois.",
  "CEXBindApiKey": "Clé API",
  "CEXBindApiSecretKey": "Clé Secrète API",
  "CEXBindApiPassphrase": "Phrase secrète API",
  "cancel": "Annuler",
  "walletLoading": "Le service de portefeuille est en cours de chargement",
  "tokenDetails": "Détails du Token",
  "tokenAmountMin": "Le montant doit être supérieur à 0.",
  "tokenAmountMax": "Solde insuffisant.",
  "tokenAddressError": "Adresse invalide.",
  "amount": "Montant",
  "amountPlaceholder": "Entrez le montant.",
  "balance": "Solde",
  "receiveTitle": "Adresse du portefeuille reçu",
  "receivePlaceholder": "Entrez l'adresse du portefeuille reçu.",
  "next": "Suivant",
  "copied": "Copié",
  "receiveQrcode": "Recevoir en scannant le code QR",
  "copyAddress": "Copier l'adresse",
  "tokenSmartContract": "Contrat intelligent du Token",
  "tokenSmartContractPlaceholder": "Entrez le contrat intelligent du Token.",
  "tokenSymbol": "Symbole du Token",
  "tokenSymbolPlaceholder": "Entrez le symbole du Token.",
  "tokenDecimals": "Décimales",
  "tokenDecimalsPlaceholder": "Entrez les décimales.",
  "import": "Importer",
  "receive": "Recevoir",
  "customizedToken": "Token personnalisé",
  "noMoreRecords": "Il n'y a plus d'enregistrements ici !",
  "noRecords": "Il n'y a aucun enregistrement ici !",
  "close": "Fermer",
  "back": "Retour",
  "importSuccess": "Importation du jeton réussie",
  "importFail": "Échec de l'importation du jeton",
  "changeNetwork": "Changer de réseau",
  "approveSuccess": "Approbation réussie",
  "Approve": "Approuver",
  "noFriends": "Pas encore d'amis",
  "noRequests": "Pas encore de demandes",
  "noMore": "Plus rien",
  "Remove": "Supprimer",
  "removeSuccess": "Suppression réussie"
}
